import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { AuthService } from './auth.service';
import { AuthTokenType } from '../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenRefreshService {

  private _authService: any;

  constructor(
    private injector: Injector,
    private http: HttpClient,
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
  ) { }

  private get authService(): any {
    if (!this._authService) {
      this._authService = this.injector.get(AuthService); // مقداردهی در زمان اجرا
    }
    return this._authService;
  }

  handleRefreshToken(): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const model = { refreshToken: this.authService.getRawAuthToken(AuthTokenType.RefreshToken) };
    const url = `${this.appConfig.apiEndpoint}/v2/${this.appConfig.refreshTokenPath}`;

    return this.http.post(url, model, { headers });
  }
}
